// extracted by mini-css-extract-plugin
export default {"intro-main":"UserIntroPrompt_intro-main__VgZUm","cross":"UserIntroPrompt_cross__3SxX-"};